import React from 'react';
import { useTranslation } from 'react-i18next';
import enTexts from './ProjekteEn.json';
import deTexts from './ProjekteDe.json';
import styles from './Projekte.module.css';
import HappyCube from './HappyCube/HappyCube';
import CrossInnovationClass from './CrossInnovationClass/CrossInnovationClass';
import DynamicClock from './DynamicClock/DynamicClock';
import Trading from './Trading/Trading';

function Projekte() {
    const { i18n } = useTranslation();
    const texts = i18n.language.startsWith('de') ? deTexts : enTexts;

    return (
        <div className={styles.container}>
            <h1>{texts.title}</h1>
            <p>{texts.text}</p>
            <div className={styles.projectsWrapper}>
                <CrossInnovationClass />
                <DynamicClock />
                <HappyCube />
                <Trading />
            </div>
        </div>
    );
}

export default Projekte;
